angular.module("app").directive("flowerLifespanAcrossFamilies", () => {
  let link = (scope) => {
    scope.$watch('data', function (newValue, oldValue) {
      if (newValue !== oldValue) {
        scope.data = newValue;
      }
    }, true);
  };

  return {
    restrict: "E",
    templateUrl: "app/directives/dbFlowerLifespanAcrossFamilies/dbFlowerLifespanAcrossFamiliesView.html",
    link: link,
    scope: {
      data: "=",
      mode: "="
    }
  };
});
